import { showAlert } from '../../Alert/Alert';

import { DEFAULT_FORMATS } from './constants';

export const generateDescription = (input) => {
  const types = input.split(',').map((type) => type.trim().toUpperCase());

  const formattedTypes =
    types.length > 1 ? types.slice(0, -1).join(', ') + ' and ' + types.slice(-1) : types[0];

  return `${formattedTypes} formats, up to 50MB.`;
};

export const getAcceptAttribute = (formats = DEFAULT_FORMATS) => {
  return formats
    .split(',')
    .map((format) => `.${format.trim()}`)
    .join(', ');
};

export const isFileAllowed = (file, formats) => {
  const fileExtension = file.name.split('.').pop().toLowerCase();
  return String(formats)
    .split(',')
    .map((format) => format.trim().replace(/^\./, '').toLowerCase())
    .includes(fileExtension);
};

export const toPendingFileEntry = (newFile) => ({
  fileId: newFile.fileId,
  name: newFile.name,
  size: newFile.size,
  uploadedSize: 0,
  type: newFile.type,
  category: newFile.category,
  status: 'idle',
  progress: 0,
  originalFile: newFile,
  key: newFile.key || null
});

export const alertInvalidFormat = (formats) =>
  showAlert({
    color: 'danger',
    title: 'Invalid format',
    message: `Please upload files in the following formats: ${formats}.`
  });

export const alertTooManyFiles = (maxFiles) =>
  showAlert({ color: 'danger', message: `Maximum ${maxFiles} files allowed` });
